<template>
    <div>
            <v-row style="width:800px;max-width:100%;margin:auto">
                <v-col v-for="option in options" :key="option.id" :style="option.isSelected?`border:1px solid ${ option.color};border-radius:10px;text-align:center`:''" @click="selectOption(option)">
                    <v-icon size="50" :color="option.color">{{option.icon}}</v-icon>
                    <label :for="`option-${option.id}`" class="image-label">{{ option.name }}</label>
                </v-col>
            </v-row>
        <!--<div v-if="selectedOptionId !== null">
            <img :src="options.find(x => x.id === selectedOptionId)?.imageSrc" :alt="`Picture ${selectedImageId}`" style="max-width: 200px;">
        </div>-->
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                default: null
            },
            items:{
                type: Array,
                required: true
            }
        },
        data() {
            return {
                options:[],
                selectedOptionId: null
            }
        },
        watch: {
            items: {
                handler(newOptions) {
                    this.options = Array.isArray(newOptions) ? newOptions.map(x => ({ ...x })) : []
                    this.selectedOptionId = null
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            selectOption(selectedOption) {
                this.options = this.options.map(x=> ({
                    ...x,
                    isSelected: x.id === selectedOption.id
                }))
                this.selectedOptionId = selectedOption.id

                // Emit the updated images list
                this.$emit('input', this.selectedOptionId)
            }
        }
    }

</script>

<style scoped>
    .options {
        display1: flex;
        justify-content: normal;
    }

        .options div {
            cursor: pointer;
            text-align: center;
            margin: 10px;
        }

        .options img {
            width: 100px;
            height: 100px;
            border-radius: 5px;
            transition: transform 0.2s;
        }

            .options img.selected {
                transform: scale(1.2);
                border: 2px solid var(--v-primary-base);
            }

    .image-label {
        display: block;
        margin-top: 5px;
        font-size: 14px;
        color: #555;
        font-weight: 700;
    }
</style>
